export default __webpack_public_path__ + "pioneer-dj.933702fe.png";